<template>
  <div class="modal-permission">
    <el-dialog
      title="权限管理"
      :visible.sync="visible"
      lock-scroll
      @close="$_cancle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="large"
    >
      <div class="content">
        <el-container v-loading="isLoading">
          <el-aside>
            <h2
              :title="modalData.systemName + '权限'"
              :style="{ margin: '10px 10px 0' }"
            >
              {{ modalData.systemName }}权限
            </h2>
            <el-scrollbar>
              <el-tree
                ref="treeRef"
                node-key="permissionId"
                lazy
                highlight-current
                empty-text="暂无数据"
                :props="treeProps"
                :load="_getChildsByParentId"
                :expand-on-click-node="false"
                :default-expanded-keys="expandedIds"
                @node-click="_selectNode"
              />
            </el-scrollbar>
          </el-aside>
          <el-main>
            <!-- 条件查询部分 -->
            <section class="filter-box">
              <div class="top-btns">
                <el-button class="btn__add" @click="_modify(-1)">
                  新增权限
                </el-button>
                <el-button class="btn__add" @click="_switch(1)"
                  >批量启用</el-button
                >
                <el-button class="btn__add" @click="_switch(2)"
                  >批量停用</el-button
                >
                <el-button class="btn__add" @click="_delete"
                  >批量删除</el-button
                >
              </div>
              <el-form :inline="true" class="filter-form">
                <el-form-item label="权限名称:">
                  <el-input
                    v-model="filter.permissionName"
                    style="width: 110px"
                  ></el-input>
                </el-form-item>

                <el-form-item label="权限编码:">
                  <el-input
                    v-model="filter.permissionCode"
                    style="width: 110px"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button class="search__btn" @click="_search"
                    >查询</el-button
                  >
                  <el-button class="reset__btn" @click="_reset">重置</el-button>
                </el-form-item>
              </el-form>
            </section>

            <main class="spas-main-table-box">
              <!-- 数据列表 -->
              <el-table
                ref="tableList"
                class="table-list__box"
                :data="dataList"
                :height="539"
                stripe
                tooltip-effect="dark"
                @selection-change="_selectionChange"
              >
                <el-table-column type="selection" width="50" />
                <!-- 常规width button数 * (80 + 10) + 30  -->
                <el-table-column label="操作" width="100" :resizable="false">
                  <template #default="scope">
                    <el-button
                      type="primary"
                      class="edit__btn"
                      @click="_modify(scope.$index, scope.row)"
                    >
                      编辑
                    </el-button>
                  </template>
                </el-table-column>
                <template v-for="column in columns">
                  <el-table-column
                    :key="column.key"
                    :prop="column.key"
                    :label="column.label"
                    :width="column.width"
                    sortable
                    show-overflow-tooltip
                    filter-placement="bottom"
                    :formatter="column.formatter"
                  ></el-table-column>
                </template>
                <el-table-column label="状态" width="70">
                  <template #default="scope">
                    <span :style="{color: scope.row.status === 1 ? '' : '#FF4040'}">{{scope.row.statusStr}}</span>
                  </template>
                </el-table-column>
                <template #empty>
                  <div slot="empty" class="table-list__empty"></div>
                </template>
              </el-table>
            </main>
          </el-main>
        </el-container>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel__btn" @click="$_cancle">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增、编辑弹窗 -->
    <ModalModify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :form-type="modal.type"
      :curr-permission="currPermission"
      :parent-list="dataList"
      :modal-data="modal.data"
      :app-id="modalData.appId"
      @callback="_callback"
      @close="_close"
    />
  </div>
</template>
<script>
import resize from "@/mixins/resize";
import ModalModify from "./modal-modify";
const columns = [
  { key: "permissionName", label: "权限名称", width: 140 },
  { key: "permissionCode", label: "权限编码", width: 110 },
  { key: "url", label: "权限路径", width: 110 },
  {
    key: "permissionTypeStr",
    label: "权限类型",
    width: 100,
  },
  { key: "sort", label: "显示顺序", width: 100 },
  { key: "iconStr", label: "菜单图标样式", width: 120 }
];
export default {
  name: "Permission",
  mixins: [resize],
  components: {
    ModalModify
  },
  props: {
    modalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      columns,
      isLoading: false,
      treeHeight: 0,
      rootItem: null,
      treeProps: {
        label: "permissionName",
        children: "childs",
      },
      dataList: [],
      selectData: [],
      currPermission: null,
      currNode: null,
      filter: {
        permissionName: "",
        permissionCode: "",
        parentPermissionCode: "ROOT",
      },
      modal: {
        data: {},
        type: "add",
        show: false,
      },
    };
  },
  computed: {
    expandedIds() {
      return this.rootItem ? [this.rootItem.permissionId] : [];
    },
  },
  mounted() {
    this.visible = true;
    this._getList();
  },
  methods: {
    async _getChildsByParentId(node, resolve) {
      const parentPermissionCode =
        node.level === 0 ? "0" : node.data.permissionCode;
      const postData = {
        appId: this.modalData.appId,
        parentPermissionCode,
      };
      const result = await this.$service.post("queryPermsList", postData);
      if (node.level === 0) {
        this.currNode = node;
        this.rootItem = result.data[0];
        this.currPermission = result.data[0];
        this.$nextTick(() => {
          if (this.$refs.treeRef) {
            this.$refs.treeRef.setCurrentKey(result.data[0].permissionId);
          }
        });
      }
      return resolve(result.data);
    },
    _selectNode(item, node, nodeRef) {
      this.filter.parentPermissionCode = item.permissionCode;
      this.currPermission = item;
      this.currNode = node;
      this._getList();
    },
    // 局部刷新tree
    _refreshTree(node) {
      node.loaded = false;
      node.expand();
    },
    // 搜索
    _search() {
      this._getList();
    },
    _reset() {
      this.filter.permissionName = "";
      this.filter.permissionCode = "";
      this._getList();
    },
    async _getList() {
      this.isLoading = true;
      try {
        await this.$service
          .post("queryPermsList", {
            appId: this.modalData.appId,
            ...this.filter,
          })
          .then((res) => {
            this.dataList = res.data;
          });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    _selectionChange(rows) {
      this.selectData = rows;
    },
    // 新增编辑
    _modify(index, row) {
      if (index === -1) {
        this.modal.title = "新增权限";
        this.modal.type = "add";
        this.modal.data = {};
      } else {
        this.modal.title = "编辑权限";
        this.modal.type = "edit";
        this.modal.data = row;
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },
    // 关闭弹窗
    _close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "";
      this.modal.data = {};
      this.modal.title = "";
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    // 新增/编辑成功回调
    _callback() {
      this._refreshTree(this.currNode); // 刷新tree

      this._close();
      this._getList();
    },

    // 更新状态
    _updateStatus(ids, status) {
      this.isLoading = true;
      try {
        this.$service
          .post("batchUpdateStatusPerms")({ ids, status })
          .then(() => {
            alertMsgBox().then(() => {
              _getList();
            });
          });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    // 停启用
    _switch(status) {
      let ids = this.selectData.map((ele) => ele.permissionId);
      if (ids.length === 0) {
        $MessageBox.alert({content: "未勾选需要进行操作的权限"});
        return false;
      }
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self._getList();
          },
        });
      };
      const self = this;
      if (status === 1) {
        // 停用切换成启用
        self.$service
          .post("batchUpdateStatusPerms", {
            ids,
            status: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              callback(result.msg);
            }
          });
      } else if (status === 2) {
        // 启用切换成停用
        $MessageBox.confirm({
          content: `
            <div>确认停用所选权限？停用后后将不可控制此权限?</div>
          `,
          onOk() {
            self.$service
              .post("batchUpdateStatusPerms", {
                ids,
                status: 2,
              })
              .then((result) => {
                if (result.$.checkResult(result, true)) {
                  callback(result.msg);
                }
              });
          },
        });
      }
    },
    // 批量删除
    _delete() {
      let ids = this.selectData.map((ele) => ele.permissionId);
      if (ids.length === 0) {
        $MessageBox.alert({content: "未勾选需要进行操作的权限"});
        return false;
      }
      const self = this;
      let content =
        "确认删除？<br />所有子级将被一起删除，是否确定删除当前权限？";
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("batchDeletePerms", {
              ids,
            })
            .then((result) => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self._getList();
                    // 刷新tree
                    self._refreshTree(self.currNode);
                  },
                });
              }
            });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 20px 30px;
}
/deep/ .el-container {
  height: 100%;
  display: flex;
  border: 1px solid #eee;
  overflow: hidden;
  .el-aside {
    box-sizing: border-box;
    background-color: #f5f5f5;
    border-right: 1px solid #eee;
    h2 {
      font-size: 14px;
      line-height: 20px;
      color: #535353;
      font-weight: bold;
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-scrollbar {
      height: calc(100% - 24px);
    }
    .el-tree {
      background-color: transparent;
      color: #535353;
      .el-tree-node__content {
        height: 20px;
      }
      .el-tree-node__label {
        font-size: 12px;
        line-height: 20px;
      }
      &.el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        background: #1895dd;
        color: #fff;
        .el-tree-node__label {
          background: #1895dd;
          color: #fff;
        }

        .el-icon {
          color: #fff;
          &.is-leaf {
            color: transparent;
          }
        }
      }
    }
  }
  .el-main {
    padding: 0;
    display: flex;
    flex-direction: column;
    width: 900px;
    .filter-box {
      padding: 12px 18px 0;
    }
    .top-btns {
      margin-bottom: 15px;
    }
    .el-table {
      .el-table__empty-block {
        width: 100% !important;
      }
      .el-table__cell:first-child .cell {
        padding-left: 10px;
        text-align: left;
      }
    }
  }
}
</style>
